var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('banner-cmp'),_c('car-model-cmp'),_c('promotion-cmp'),_c('model-photos-cmp'),_c('latest-news-cmp'),_c('contact-us-cmp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }